import React, { useState, useEffect } from "react";
import { Table, Card, Button, Select, Layout, message, Row, Col} from "antd";
import { CSVLink } from "react-csv";
import { DoubleLeftOutlined, DoubleRightOutlined, LeftOutlined, RightOutlined, DownloadOutlined } from "@ant-design/icons";
import Sidebar from "../../Side_Bar/Admin_Side_Bar.js";
import { BrowserRouter as Router, Switch, Route, Link, useLocation } from 'react-router-dom';

const ScrollableTable  = () => {
  const location = useLocation();
  
  const timePeriodOptions = ["Daily", "Monthly", "Yearly"];
  const [selectedTimePeriod, setSelectedTimePeriod] = useState(
    timePeriodOptions[0]
  );

  const [contractOptions, setContractOptions] = useState([]);
  const [contractIds, setContractIds] = useState([]);
  const [selectedContract, setSelectedContract] = useState('');
  const [id, setId] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);

  const mainUrl                           = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  
  const [data, setData] = useState([]);
  
  const [pricing_data, setCustomerPricing] = useState([]);
  const [company_pricing, setCompanyPricing] = useState([]);

  const [uniqueNumMonthly, setUniqueNumMonthly] = useState([]);
  const [uniqueSessMonthly, setUniqueSessMonthly] = useState([]);

  const [uniqueNumDaily, setUniqueNumDaily] = useState([]);
  const [uniqueSessDaily, setUniqueSessDaily] = useState([]);

  const [uniqueNumYearly, setUniqueNumYearly] = useState([]);
  const [uniqueSessYearly, setUniqueSessYearly] = useState([]);

  const [payment_data, setPaymentData] = useState([]);

  // Simulated fetch of customer data
  useEffect(() => {
    // Function to fetch data from a given URL
    const fetchData = async (url) => {     
      try {
        const response = await fetch(url);
        const data = await response.json();
        // console.log(`Data from ${url}:`, data);
        return data;
      } catch (error) {
        console.error(`Error fetching data from ${url}:`, error);
        throw error;
      }
    };

    const fetchDataAPI = async () =>{
      if (id != -1){
        setIsLoading(true);
        // URLs for your API endpoints
        const messagesUrl                 = `${mainUrl}/getTable?tableName=Message&contract_id=${id}`;

        
        const CustomerPricingRateUrl      = `${mainUrl}/getTable?tableName=Customer_Pricing&contract_id=${id}`;
        const CompanyPricingRateUrl       = `${mainUrl}/getTable?tableName=Company_Pricing&contract_id=${id}`;

        const uniqueNumbersMonthlyUrl     = `${mainUrl}/getUniqueNumbersMonthly?contract_id=${id}`;
        const uniqueSessionsMonthlyUrl    = `${mainUrl}/getUniqueSessionsMonthly?contract_id=${id}`;

        const uniqueNumbersDailyUrl       = `${mainUrl}/getUniqueNumbersDaily?contract_id=${id}`;
        const uniqueSessionsDailyUrl      = `${mainUrl}/getUniqueSessionsDaily?contract_id=${id}`;

        const uniqueNumbersYearlyUrl      = `${mainUrl}/getUniqueNumbersYearly?contract_id=${id}`;
        const uniqueSessionsYearlyUrl     = `${mainUrl}/getUniqueSessionsYearly?contract_id=${id}`;
      
        const paymentUrl                  = `${mainUrl}/getTable?tableName=Contract&contract_id=${id}`;

        setData(await fetchData(messagesUrl));
        
        setCustomerPricing(await fetchData(CustomerPricingRateUrl));
        setCompanyPricing(await fetchData(CompanyPricingRateUrl));
        
        setUniqueNumMonthly(await fetchData(uniqueNumbersMonthlyUrl));
        setUniqueSessMonthly(await fetchData(uniqueSessionsMonthlyUrl));

        setUniqueNumDaily(await fetchData(uniqueNumbersDailyUrl));
        setUniqueSessDaily(await fetchData(uniqueSessionsDailyUrl));
        
        setUniqueNumYearly(await fetchData(uniqueNumbersYearlyUrl));
        setUniqueSessYearly(await fetchData(uniqueSessionsYearlyUrl));

        setPaymentData(await fetchData(paymentUrl));
        
        setIsLoading(false);
        
      }else{
        console.log("ID is -1");
      }
    }
    
    fetchDataAPI();

  }, [id]);

  useEffect(() => {
    const fetchContractData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getAllTable?tableName=Contract`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      } catch (error) {
        console.error('Error fetching table data:', error);
        // Handle error appropriately, e.g., set an error state
        throw error; // Re-throw the error for the calling function to handle
      }
    };
  
    const fetchContractDataAPI = async () => {
      try {
        const contractList = await fetchContractData();
  
        const contracts = contractList.map(contract => ({
          id: contract.contract_id,
          name: contract.name,
        }));
  
        setContractIds(contracts);
        setId(contracts[0].id);
  
        setSelectedContract(contracts[0].name);
        setContractOptions(contracts.map(contract => contract.name));
  
      } catch (error) {
        // Handle error, e.g., show an error message to the user
        console.error('Error fetching data:', error);
      }
    };
  
    // Call the asynchronous function directly within useEffect
    fetchContractDataAPI();
  }, []); // Empty dependency array to ensure the effect runs once on mount
  
  const handleDropdownChange = (value, selectedIndex) => {
    // Use selectedIndex as needed
    console.log("Selected Index:", selectedIndex);

    setId(contractIds[selectedIndex].id)

    setSelectedContract(contractIds[selectedIndex].name);
  };

  useEffect(() => {
    if (pricing_data.length != 0){
      console.log(pricing_data)
      filterDataByTimePeriod(selectedTimePeriod, data, uniqueNumDaily, uniqueSessDaily, payment_data, pricing_data);
    }
  }, [selectedTimePeriod, id, data, uniqueNumDaily, uniqueSessDaily, payment_data]);


  let generatedData = [];
  let cost_authentication         = new Map();
  let cost_service                = new Map();
  let cost_utility                = new Map();
  let cost_marketing              = new Map();
  let cost_unknown                = new Map();

  let cost_map                    = new Map();

  let revenue_map                 = new Map();
  
  let users_map                   = new Map();

  let no_messages                 = new Map();

  let no_messages_authentication  = new Map();
  let no_messages_service         = new Map();
  let no_messages_utility         = new Map();
  let no_messages_marketing       = new Map();
  let no_messages_unknown         = new Map();

  let revenue_authentication      = new Map();
  let revenue_service             = new Map();
  let revenue_utility             = new Map();
  let revenue_marketing           = new Map();
  let revenue_unknown             = new Map();

  let uniqueSession               = new Map();
  let uniqueNumbers               = new Map();

  let prepaid_monthly_map         = new Map();
  let prepaid_full_map            = new Map();
  let prepaid_accumulation_map    = new Map();

  const filterDataByTimePeriod = (selectedTimePeriod, data, uniqueNumDaily, uniqueSessDaily, payment_data) => {
    
    switch (selectedTimePeriod) {
      case "Daily":
        cost_authentication.clear();
        cost_service.clear();
        cost_utility.clear();
        cost_marketing.clear();
        cost_unknown.clear();

        cost_map.clear();

        revenue_map.clear();

        no_messages.clear();

        no_messages_authentication.clear();
        no_messages_service.clear();
        no_messages_utility.clear();
        no_messages_marketing.clear();
        no_messages_unknown.clear();

        revenue_authentication.clear();
        revenue_service.clear();
        revenue_utility.clear();
        revenue_marketing.clear();
        revenue_unknown.clear();

        uniqueSession.clear();
        uniqueNumbers.clear();

        prepaid_monthly_map.clear();
        prepaid_full_map.clear();

        for (let i = 0; i<uniqueNumDaily.length; i++){
          uniqueNumbers.set(uniqueNumDaily.at(i).day, uniqueNumDaily.at(i).unique_acc_from_count);
        }

        for (let i = 0; i<uniqueSessDaily.length; i++){
          uniqueSession.set(uniqueSessDaily.at(i).day, uniqueSessDaily.at(i).num_sessions);
        }
        
        for(let i =0; i<data.length; i++){
          const year  = data.at(i).date_sent.split("T")[0].split("-")[0];
          const month = data.at(i).date_sent.split("T")[0].split("-")[1];
          const day   = data.at(i).date_sent.split("T")[0].split("-")[2];

          if(cost_map.get(year + "-" + month + "-" + day) == undefined){
            cost_map.set(year + "-" + month + "-" + day, data.at(i).company_cost);
          }else{
            cost_map.set(year + "-" + month + "-" + day , cost_map.get(year + "-" + month + "-" + day) + data.at(i).company_cost);
          }

          for(let i = 0; i<payment_data.length; i++){
            const payment_obj = payment_data.at(i);
            let month_payment = parseInt(payment_obj.start_date.split("-")[1]);
            let year_payment  = parseInt(payment_obj.start_date.split("-")[0]);

            // Use payment_obj.quantity as the number of months to extend the coverage
            const target_month = (month_payment + payment_obj.monthly_duration) % 12 || 12;
            const target_year = year_payment + Math.floor((month_payment + payment_obj.monthly_duration) / 12);
            if (
              (parseInt(year) > year_payment && parseInt(year) < target_year) ||
              (parseInt(year) === year_payment && parseInt(month) >= month_payment && parseInt(month) < target_month) ||
              (parseInt(year) === year_payment && parseInt(month) >= month_payment && parseInt(year) < target_year) ||
              (parseInt(year) === target_year && parseInt(month) < target_month)
            ) {
              prepaid_monthly_map.set(year + "-" + month + "-" + day, payment_obj.prepaid_amount);
              prepaid_full_map.set(year + "-" + month + "-" + day, payment_obj.prepaid_amount*payment_obj.monthly_duration)
            }
          }

          if(no_messages.get(year + "-" + month + "-" + day) == undefined){
            no_messages.set(year + "-" + month + "-" + day, 1);
          }else{
            no_messages.set(year + "-" + month + "-" + day, no_messages.get(year + "-" + month + "-" + day) + 1);
          }
      
          switch (data.at(i).message_type){
            case "Unknown Type":
              // Number of messages
              if(no_messages_unknown.get(year + "-" + month + "-" + day) == undefined){
                no_messages_unknown.set(year + "-" + month + "-" + day, 1);
              }else{
                no_messages_unknown.set(year + "-" + month + "-" + day, no_messages_unknown.get(year + "-" + month + "-" + day) + 1);
              }
      
              // Cost per message to company
              if(cost_unknown.get(year + "-" + month + "-" + day) == undefined){
                cost_unknown.set(year + "-" + month + "-" + day, data.at(i).company_cost);
                revenue_unknown.set(year + "-" + month + "-" + day, data.at(i).customer_cost);
              }else{
                cost_unknown.set(year + "-" + month + "-" + day, cost_unknown.get(year + "-" + month + "-" + day) + data.at(i).company_cost);
                revenue_unknown.set(year + "-" + month + "-" + day, revenue_unknown.get(year + "-" + month + "-" + day) + data.at(i).customer_cost);
              }
      
              break;
            case "Marketing":
              if(no_messages_marketing.get(year + "-" + month + "-" + day) == undefined){
                no_messages_marketing.set(year + "-" + month + "-" + day, 1);
              }else{
                no_messages_marketing.set(year + "-" + month + "-" + day, no_messages_marketing.get(year + "-" + month + "-" + day) + 1);
              }
      
              // Cost per message to company
              if(cost_marketing.get(year + "-" + month + "-" + day) == undefined){
                cost_marketing.set(year + "-" + month + "-" + day, data.at(i).company_cost);
                revenue_marketing.set(year + "-" + month + "-" + day, data.at(i).customer_cost);
              }else{
                cost_marketing.set(year + "-" + month + "-" + day, cost_marketing.get(year + "-" + month + "-" + day) + data.at(i).company_cost);
                revenue_marketing.set(year + "-" + month + "-" + day, revenue_marketing.get(year + "-" + month + "-" + day) + data.at(i).customer_cost);
              }
      
              break;
            case "Authentication":
              if(no_messages_authentication.get(year + "-" + month + "-" + day) == undefined){
                no_messages_authentication.set(year + "-" + month + "-" + day, 1);
              }else{
                no_messages_authentication.set(year + "-" + month + "-" + day, no_messages_authentication.get(year + "-" + month + "-" + day) + 1);
              }
      
              // Cost per message to company
              if(cost_authentication.get(year + "-" + month + "-" + day) == undefined){
                cost_authentication.set(year + "-" + month + "-" + day, data.at(i).company_cost);
                revenue_authentication.set(year + "-" + month + "-" + day, data.at(i).customer_cost);
              }else{
                cost_authentication.set(year + "-" + month + "-" + day, cost_authentication.get(year + "-" + month + "-" + day) + data.at(i).company_cost);
                revenue_authentication.set(year + "-" + month + "-" + day, revenue_authentication.get(year + "-" + month + "-" + day) + data.at(i).customer_cost);
              }
              break;
            case "Utility":
              if(no_messages_utility.get(year + "-" + month + "-" + day) == undefined){
                no_messages_utility.set(year + "-" + month + "-" + day, 1);
              }else{
                no_messages_utility.set(year + "-" + month + "-" + day, no_messages_utility.get(year + "-" + month + "-" + day) + 1);
              }
      
              // Cost per message to company
              if(cost_utility.get(year + "-" + month + "-" + day) == undefined){
                cost_utility.set(year + "-" + month + "-" + day, data.at(i).company_cost);
                revenue_utility.set(year + "-" + month + "-" + day, data.at(i).customer_cost);
              }else{
                cost_utility.set(year + "-" + month + "-" + day, cost_utility.get(year + "-" + month + "-" + day) + data.at(i).company_cost);
                revenue_utility.set(year + "-" + month + "-" + day, revenue_utility.get(year + "-" + month + "-" + day) + data.at(i).customer_cost);
              }
              break;
            case "Service":
              if(no_messages_service.get(year + "-" + month + "-" + day) == undefined){
                no_messages_service.set(year + "-" + month + "-" + day, 1);
              }else{
                no_messages_service.set(year + "-" + month + "-" + day, no_messages_service.get(year + "-" + month + "-" + day) + 1);
              }
      
              // Cost per message to company
              if(cost_service.get(year + "-" + month + "-" + day) == undefined){
                cost_service.set(year + "-" + month + "-" + day, data.at(i).company_cost);
                revenue_service.set(year + "-" + month + "-" + day, data.at(i).customer_cost);
              }else{
                cost_service.set(year + "-" + month + "-" + day, cost_service.get(year + "-" + month + "-" + day) + data.at(i).company_cost);
                revenue_service.set(year + "-" + month + "-" + day, revenue_service.get(year + "-" + month + "-" + day) + data.at(i).customer_cost);
              }
              break;
            default:
              break;
          }
      
          if(users_map.get(data.at(i).acc_from) == undefined){
            users_map.set(data.at(i).acc_from, 1);
          }else{
            users_map.set(data.at(i).acc_from, users_map.get(data.at(i).acc_from) + 1);
          }
          
        }
        setDummyData([]);
        // Initialize an array to store the generated entries
        generatedData = [];

        // Loop through all entries in monthly_cost_map
        for (const [date, sessionRMCost] of cost_map.entries()) {
          const entry = {
            Date: date,
            SessionRM: ((uniqueNumbers.get(date) || 0)*pricing_data[0].session),
            Contract: selectedContract,
            TotalMsg: no_messages.get(date),
            MarketingMsg: no_messages_marketing.get(date) || 0,
            ServiceMsg: no_messages_service.get(date) || 0,
            UtilityMsg: no_messages_utility.get(date) || 0,
            UknownTypeMsg: no_messages_unknown.get(date) || 0,
            AuthenticationMsg: no_messages_authentication.get(date) || 0,
            TotalUniqueSession: uniqueSession.get(date) || 0,
            TotalUniqueUser: uniqueNumbers.get(date) || 0, 
            MarketingRM: (cost_marketing.get(date) || 0).toFixed(2),
            ServiceRM: (cost_service.get(date) || 0).toFixed(2),
            UtilityRM: (cost_utility.get(date) || 0).toFixed(2),
            UknownTypeRM: (cost_unknown.get(date) || 0).toFixed(2),
            AuthenticationRM: (cost_authentication.get(date) || 0).toFixed(2),
            PrepaidFullPeriodRM: "-", /*prepaid_full_map.get(date) || 0,*/ // DO LATER (3) ------ DONE
            PrepaidMonthlyRM: "-", /*prepaid_monthly_map.get(date) || 0, */ // DO LATER (2) ------ DONE
            MonthlyPrepaidAccumulationRM: "-", // DO LATER
            MonthlyUsageRM: (cost_map.get(date) || 0).toFixed(2),
            ContractUsageToDateRM: 0, // Set initially to 0 before accumulation ------ DONE
            MonthlyBalanceRM: "-", /*Number(prepaid_monthly_map.get(date) || 0) + Number((cost_map.get(date) || 0).toFixed(2)),*/ // DO LATER (5)
            ContractPrepaidBalanceRM: "-", 
            PLMarketing: Number((revenue_marketing.get(date) || 0).toFixed(2)) + Number((cost_marketing.get(date) || 0).toFixed(2)),
            PLService: Number((revenue_service.get(date) || 0).toFixed(2)) + Number((cost_service.get(date) || 0).toFixed(2)),
            PLUtility: Number((revenue_utility.get(date) || 0).toFixed(2)) + Number((cost_utility.get(date) || 0).toFixed(2)),
            PLAuth: Number((revenue_authentication.get(date) || 0).toFixed(2)) + Number((cost_authentication.get(date) || 0).toFixed(2)),
            PLUnkown: Number((revenue_unknown.get(date) || 0).toFixed(2)) + Number((cost_unknown.get(date) || 0).toFixed(2)),
            PLSession: Number(((uniqueNumbers.get(date) || 0) * pricing_data[0].session).toFixed(2)) - parseFloat(((uniqueNumbers.get(date) || 0) * company_pricing[0].session).toFixed(2)), //DO LATER (7)
          };

          // Add the entry to the array
          generatedData.push(entry);
        }

        function compareDates(a, b) {
          const dateA = new Date(a.Date);
          const dateB = new Date(b.Date);
          return dateA - dateB;
        }

        // Sort the generatedData array using the custom comparator
        generatedData.sort(compareDates);

        for(let i=0; i<generatedData.length; i++){
          if(i != 0){
            const previousContractUsageToDateRM = Number(generatedData.at(i - 1).ContractUsageToDateRM) || 0;


            //const previousPrepaidAccumulation = Number(generatedData.at(i - 1).MonthlyPrepaidAccumulationRM) || 0;


            const currentContractUsageToDateRM = previousContractUsageToDateRM + Number(generatedData.at(i).MonthlyUsageRM);
            //const currentPrepaidAccumulation = previousPrepaidAccumulation + Number(generatedData.at(i).PrepaidMonthlyRM);

            generatedData.at(i).ContractUsageToDateRM = currentContractUsageToDateRM.toFixed(2);
            //generatedData.at(i).MonthlyPrepaidAccumulationRM = currentPrepaidAccumulation.toFixed(2);

          }else{
            generatedData.at(i).ContractUsageToDateRM = Number(generatedData.at(i).MonthlyUsageRM).toFixed(2);
            generatedData.at(i).MonthlyPrepaidAccumulationRM = Number(generatedData.at(i).PrepaidMonthlyRM).toFixed(2);
          }

        }

        function compareDatesReverse(a, b) {
          const dateA = new Date(a.Date);
          const dateB = new Date(b.Date);
          return dateB - dateA;
        }

        generatedData.sort(compareDatesReverse);


        setDummyData((prevData) => [...prevData, ...generatedData]);
        break;
      case "Monthly":
        cost_authentication.clear();
        cost_service.clear();
        cost_utility.clear();
        cost_marketing.clear();
        cost_unknown.clear();

        cost_map.clear();

        revenue_map.clear();

        no_messages.clear();

        no_messages_authentication.clear();
        no_messages_service.clear();
        no_messages_utility.clear();
        no_messages_marketing.clear();
        no_messages_unknown.clear();

        revenue_authentication.clear();
        revenue_service.clear();
        revenue_utility.clear();
        revenue_marketing.clear();
        revenue_unknown.clear();

        uniqueSession.clear();
        uniqueNumbers.clear();

        prepaid_monthly_map.clear();
        prepaid_full_map.clear();

        for (let i = 0; i<uniqueNumMonthly.length; i++){
          uniqueNumbers.set(uniqueNumMonthly.at(i).month, uniqueNumMonthly.at(i).unique_acc_from_count);
        }

        for (let i = 0; i<uniqueSessMonthly.length; i++){
          uniqueSession.set(uniqueSessMonthly.at(i).month, uniqueSessMonthly.at(i).num_sessions);
        }

        for(let i =0; i<data.length; i++){
          const year  = data.at(i).date_sent.split("T")[0].split("-")[0];
          const month = data.at(i).date_sent.split("T")[0].split("-")[1];

          if(cost_map.get(year + "-" + month) == undefined){
            cost_map.set(year + "-" + month, data.at(i).company_cost);
          }else{
            cost_map.set(year + "-" + month , cost_map.get(year + "-" + month) + data.at(i).company_cost);
          }
      
          if(no_messages.get(year + "-" + month) == undefined){
            no_messages.set(year + "-" + month, 1);
          }else{
            no_messages.set(year + "-" + month, no_messages.get(year + "-" + month) + 1);
          }

          for(let i = 0; i<payment_data.length; i++){
            const payment_obj = payment_data.at(i);
            let month_payment = parseInt(payment_obj.start_date.split("-")[1]);
            let year_payment  = parseInt(payment_obj.start_date.split("-")[0]);

            // Use payment_obj.quantity as the number of months to extend the coverage
            const target_month = (month_payment + payment_obj.monthly_duration) % 12 || 12;
            const target_year = year_payment + Math.floor((month_payment + payment_obj.monthly_duration) / 12);
            if (
              (parseInt(year) > year_payment && parseInt(year) < target_year) ||
              (parseInt(year) === year_payment && parseInt(month) >= month_payment && parseInt(month) < target_month) ||
              (parseInt(year) === year_payment && parseInt(month) >= month_payment && parseInt(year) < target_year) ||
              (parseInt(year) === target_year && parseInt(month) < target_month)
            ) {
              prepaid_monthly_map.set(year + "-" + month, payment_obj.prepaid_amount);
              prepaid_full_map.set(year + "-" + month, payment_obj.prepaid_amount*payment_obj.monthly_duration)
            }
          }
      
          switch (data.at(i).message_type){
            case "Unknown Type":
              // Number of messages
              if(no_messages_unknown.get(year + "-" + month) == undefined){
                no_messages_unknown.set(year + "-" + month, 1);
              }else{
                no_messages_unknown.set(year + "-" + month, no_messages_unknown.get(year + "-" + month) + 1);
              }
      
              // Cost per message to company
              if(cost_unknown.get(year + "-" + month) == undefined){
                cost_unknown.set(year + "-" + month, data.at(i).company_cost);
                revenue_unknown.set(year + "-" + month, data.at(i).customer_cost);
              }else{
                cost_unknown.set(year + "-" + month, cost_unknown.get(year + "-" + month) + data.at(i).company_cost);
                revenue_unknown.set(year + "-" + month, revenue_unknown.get(year + "-" + month) + data.at(i).customer_cost);
              }
      
              break;
            case "Marketing":
              if(no_messages_marketing.get(year + "-" + month) == undefined){
                no_messages_marketing.set(year + "-" + month, 1);
              }else{
                no_messages_marketing.set(year + "-" + month, no_messages_marketing.get(year + "-" + month) + 1);
              }
      
              // Cost per message to company
              if(cost_marketing.get(year + "-" + month) == undefined){
                cost_marketing.set(year + "-" + month, data.at(i).company_cost);
                revenue_marketing.set(year + "-" + month, data.at(i).customer_cost);
              }else{
                cost_marketing.set(year + "-" + month, cost_marketing.get(year + "-" + month) + data.at(i).company_cost);
                revenue_marketing.set(year + "-" + month, revenue_marketing.get(year + "-" + month) + data.at(i).customer_cost);
              }
      
              break;
            case "Authentication":
              if(no_messages_authentication.get(year + "-" + month) == undefined){
                no_messages_authentication.set(year + "-" + month, 1);
              }else{
                no_messages_authentication.set(year + "-" + month, no_messages_authentication.get(year + "-" + month) + 1);
              }
      
              // Cost per message to company
              if(cost_authentication.get(year + "-" + month) == undefined){
                cost_authentication.set(year + "-" + month, data.at(i).company_cost);
                revenue_authentication.set(year + "-" + month, data.at(i).customer_cost);
              }else{
                cost_authentication.set(year + "-" + month, cost_authentication.get(year + "-" + month) + data.at(i).company_cost);
                revenue_authentication.set(year + "-" + month, revenue_authentication.get(year + "-" + month) + data.at(i).customer_cost);
              }
              break;
            case "Utility":
              if(no_messages_utility.get(year + "-" + month) == undefined){
                no_messages_utility.set(year + "-" + month, 1);
              }else{
                no_messages_utility.set(year + "-" + month, no_messages_utility.get(year + "-" + month) + 1);
              }
      
              // Cost per message to company
              if(cost_utility.get(year + "-" + month) == undefined){
                cost_utility.set(year + "-" + month, data.at(i).company_cost);
                revenue_utility.set(year + "-" + month, data.at(i).customer_cost);
              }else{
                cost_utility.set(year + "-" + month, cost_utility.get(year + "-" + month) + data.at(i).company_cost);
                revenue_utility.set(year + "-" + month, revenue_utility.get(year + "-" + month) + data.at(i).customer_cost);
              }
              break;
            case "Service":
              if(no_messages_service.get(year + "-" + month) == undefined){
                no_messages_service.set(year + "-" + month, 1);
              }else{
                no_messages_service.set(year + "-" + month, no_messages_service.get(year + "-" + month) + 1);
              }
      
              // Cost per message to company
              if(cost_service.get(year + "-" + month) == undefined){
                cost_service.set(year + "-" + month, data.at(i).company_cost);
                revenue_service.set(year + "-" + month, data.at(i).customer_cost);
              }else{
                cost_service.set(year + "-" + month, cost_service.get(year + "-" + month) + data.at(i).company_cost);
                revenue_service.set(year + "-" + month, revenue_service.get(year + "-" + month) + data.at(i).customer_cost);
              }
              break;
            default:
              break;
          }
      
          if(users_map.get(data.at(i).acc_from) == undefined){
            users_map.set(data.at(i).acc_from, 1);
          }else{
            users_map.set(data.at(i).acc_from, users_map.get(data.at(i).acc_from) + 1);
          }
          
        }
        setDummyData([]);
        // Initialize an array to store the generated entries
        generatedData = [];
        // Loop through all entries in monthly_cost_map
        for (const [date, sessionRMCost] of cost_map.entries()) {
          // Create an object with Date and SessionRM properties
          const entry = {
            Date: date,
            SessionRM: ((uniqueNumbers.get(date) || 0)*pricing_data[0].session).toFixed(2),
            Contract: selectedContract,
            TotalMsg: no_messages.get(date),
            MarketingMsg: no_messages_marketing.get(date) || 0,
            ServiceMsg: no_messages_service.get(date) || 0,
            UtilityMsg: no_messages_utility.get(date) || 0,
            UknownTypeMsg: no_messages_unknown.get(date) || 0,
            AuthenticationMsg: no_messages_authentication.get(date) || 0,
            TotalUniqueSession: uniqueSession.get(date) || 0,
            TotalUniqueUser: uniqueNumbers.get(date) || 0, 
            MarketingRM: (cost_marketing.get(date) || 0).toFixed(2),
            ServiceRM: (cost_service.get(date) || 0).toFixed(2),
            UtilityRM: (cost_utility.get(date) || 0).toFixed(2),
            UknownTypeRM: (cost_unknown.get(date) || 0).toFixed(2),
            AuthenticationRM: (cost_authentication.get(date) || 0).toFixed(2),
            PrepaidFullPeriodRM: prepaid_full_map.get(date) || 0, // DO LATER (3) ------ DONE
            PrepaidMonthlyRM: prepaid_monthly_map.get(date) || 0, // DO LATER (2) ------ DONE
            MonthlyPrepaidAccumulationRM: 0, // Set initially to 0 before accumulation ------ DONE
            MonthlyUsageRM: (cost_map.get(date) || 0).toFixed(2),
            ContractUsageToDateRM: 0, // Set initially to 0 before accumulation ------ DONE
            MonthlyBalanceRM: Number(prepaid_monthly_map.get(date) || 0) + Number((cost_map.get(date) || 0).toFixed(2)), // DO LATER (5)
            ContractPrepaidBalanceRM: 0, // DO LATER (4) ------ Set initially to 0 since we need ContractUsageToDateRM ------ DONE
            PLMarketing: Number((revenue_marketing.get(date) || 0).toFixed(2)) + Number((cost_marketing.get(date) || 0).toFixed(2)),
            PLService: Number((revenue_service.get(date) || 0).toFixed(2)) + Number((cost_service.get(date) || 0).toFixed(2)),
            PLUtility: Number((revenue_utility.get(date) || 0).toFixed(2)) + Number((cost_utility.get(date) || 0).toFixed(2)),
            PLAuth: Number((revenue_authentication.get(date) || 0).toFixed(2)) + Number((cost_authentication.get(date) || 0).toFixed(2)),
            PLUnkown: Number((revenue_unknown.get(date) || 0).toFixed(2)) + Number((cost_unknown.get(date) || 0).toFixed(2)),
            PLSession: Number(((uniqueNumbers.get(date) || 0) * pricing_data[0].session).toFixed(2)) - parseFloat(((uniqueNumbers.get(date) || 0) * company_pricing[0].session).toFixed(2)), //DO LATER (7)
          };

          // Add the entry to the array
          generatedData.push(entry);
        }

        // Sort the generatedData array using the custom comparator
        generatedData.sort(compareDates);

        for(let i=0; i<generatedData.length; i++){
          if(i != 0){
            const previousContractUsageToDateRM = Number(generatedData.at(i - 1).ContractUsageToDateRM) || 0;


            const previousPrepaidAccumulation = Number(generatedData.at(i - 1).MonthlyPrepaidAccumulationRM) || 0;


            const currentContractUsageToDateRM = previousContractUsageToDateRM + Number(generatedData.at(i).MonthlyUsageRM);
            const currentPrepaidAccumulation = previousPrepaidAccumulation + Number(generatedData.at(i).PrepaidMonthlyRM);

            generatedData.at(i).ContractUsageToDateRM = currentContractUsageToDateRM.toFixed(2);
            generatedData.at(i).MonthlyPrepaidAccumulationRM = currentPrepaidAccumulation.toFixed(2);

          }else{
            generatedData.at(i).ContractUsageToDateRM = Number(generatedData.at(i).MonthlyUsageRM).toFixed(2);
            generatedData.at(i).MonthlyPrepaidAccumulationRM = Number(generatedData.at(i).PrepaidMonthlyRM).toFixed(2);
          }

          generatedData.at(i).ContractPrepaidBalanceRM = (Number(generatedData.at(i).ContractUsageToDateRM).toFixed(2)) + (generatedData.at(i).prepaid_full_map || 0);
        }

        generatedData.sort(compareDatesReverse);
        setDummyData((prevData) => [...prevData, ...generatedData]);
        break;
      case "Yearly":
        cost_authentication.clear();
        cost_service.clear();
        cost_utility.clear();
        cost_marketing.clear();
        cost_unknown.clear();

        cost_map.clear();

        no_messages.clear();

        no_messages_authentication.clear();
        no_messages_service.clear();
        no_messages_utility.clear();
        no_messages_marketing.clear();
        no_messages_unknown.clear();

        revenue_authentication.clear();
        revenue_service.clear();
        revenue_utility.clear();
        revenue_marketing.clear();
        revenue_unknown.clear();

        uniqueSession.clear();
        uniqueNumbers.clear();

        for (let i = 0; i<uniqueNumYearly.length; i++){
          uniqueNumbers.set(uniqueNumYearly.at(i).year, uniqueNumYearly.at(i).unique_acc_from_count);
        }

        for (let i = 0; i<uniqueSessYearly.length; i++){
          uniqueSession.set(uniqueSessYearly.at(i).year, uniqueSessYearly.at(i).num_sessions);
        }

        for(let i =0; i<data.length; i++){
          const year  = data.at(i).date_sent.split("T")[0].split("-")[0];

          if(cost_map.get(year) == undefined){
            cost_map.set(year, data.at(i).company_cost);
          }else{
            cost_map.set(year , cost_map.get(year) + data.at(i).company_cost);
          }
      
          if(no_messages.get(year) == undefined){
            no_messages.set(year, 1);
          }else{
            no_messages.set(year, no_messages.get(year) + 1);
          }
      
          switch (data.at(i).message_type){
            case "Unknown Type":
              // Number of messages
              if(no_messages_unknown.get(year) == undefined){
                no_messages_unknown.set(year, 1);
              }else{
                no_messages_unknown.set(year, no_messages_unknown.get(year) + 1);
              }
      
              // Cost per message to company
              if(cost_unknown.get(year) == undefined){
                cost_unknown.set(year, data.at(i).company_cost);
                revenue_unknown.set(year, data.at(i).customer_cost);
              }else{
                cost_unknown.set(year, cost_unknown.get(year) + data.at(i).company_cost);
                revenue_unknown.set(year, revenue_unknown.get(year) + data.at(i).customer_cost);
              }
      
              break;
            case "Marketing":
              if(no_messages_marketing.get(year) == undefined){
                no_messages_marketing.set(year, 1);
              }else{
                no_messages_marketing.set(year, no_messages_marketing.get(year) + 1);
              }
      
              // Cost per message to company
              if(cost_marketing.get(year) == undefined){
                cost_marketing.set(year, data.at(i).company_cost);
                revenue_marketing.set(year, data.at(i).customer_cost);
              }else{
                cost_marketing.set(year, cost_marketing.get(year) + data.at(i).company_cost);
                revenue_marketing.set(year, revenue_marketing.get(year) + data.at(i).customer_cost);
              }
      
              break;
            case "Authentication":
              if(no_messages_authentication.get(year) == undefined){
                no_messages_authentication.set(year, 1);
              }else{
                no_messages_authentication.set(year, no_messages_authentication.get(year) + 1);
              }
      
              // Cost per message to company
              if(cost_authentication.get(year) == undefined){
                cost_authentication.set(year, data.at(i).company_cost);
                revenue_authentication.set(year, data.at(i).customer_cost);
              }else{
                cost_authentication.set(year, cost_authentication.get(year) + data.at(i).company_cost);
                revenue_authentication.set(year, revenue_authentication.get(year) + data.at(i).customer_cost);
              }
              break;
            case "Utility":
              if(no_messages_utility.get(year) == undefined){
                no_messages_utility.set(year, 1);
              }else{
                no_messages_utility.set(year, no_messages_utility.get(year) + 1);
              }
      
              // Cost per message to company
              if(cost_utility.get(year) == undefined){
                cost_utility.set(year, data.at(i).company_cost);
                revenue_utility.set(year, data.at(i).customer_cost);
              }else{
                cost_utility.set(year, cost_utility.get(year) + data.at(i).company_cost);
                revenue_utility.set(year, revenue_utility.get(year) + data.at(i).customer_cost);
              }
              break;
            case "Service":
              if(no_messages_service.get(year) == undefined){
                no_messages_service.set(year, 1);
              }else{
                no_messages_service.set(year, no_messages_service.get(year) + 1);
              }
      
              // Cost per message to company
              if(cost_service.get(year) == undefined){
                cost_service.set(year, data.at(i).company_cost);
                revenue_service.set(year, data.at(i).customer_cost);
              }else{
                cost_service.set(year, cost_service.get(year) + data.at(i).company_cost);
                revenue_service.set(year, revenue_service.get(year) + data.at(i).customer_cost);
              }
              break;
            default:
              break;
          }
      
          if(users_map.get(data.at(i).acc_from) == undefined){
            users_map.set(data.at(i).acc_from, 1);
          }else{
            users_map.set(data.at(i).acc_from, users_map.get(data.at(i).acc_from) + 1);
          }
          
        }
        setDummyData([]);
        // Initialize an array to store the generated entries
        generatedData = [];
        // Loop through all entries in monthly_cost_map
        for (const [date, sessionRMCost] of cost_map.entries()) {
          // Create an object with Date and SessionRM properties
          const entry = {
            Date: date,
            SessionRM: ((uniqueNumbers.get(parseInt(date)) || 0)*pricing_data[0].session).toFixed(2),
            Contract: selectedContract,
            TotalMsg: no_messages.get(date),
            MarketingMsg: no_messages_marketing.get(date) || 0,
            ServiceMsg: no_messages_service.get(date) || 0,
            UtilityMsg: no_messages_utility.get(date) || 0,
            UknownTypeMsg: no_messages_unknown.get(date) || 0,
            AuthenticationMsg: no_messages_authentication.get(date) || 0,
            TotalUniqueSession: uniqueSession.get(date) || 0, // DO LATER
            TotalUniqueUser: uniqueNumbers.get(parseInt(date)) || 0, // DO LATER
            MarketingRM: cost_marketing.get(date) || 0,
            ServiceRM: cost_service.get(date) || 0,
            UtilityRM: cost_utility.get(date) || 0,
            UknownTypeRM: cost_unknown.get(date).toFixed(2) || 0,
            AuthenticationRM: cost_authentication.get(date) || 0,
            PrepaidFullPeriodRM: "-", // DO LATER
            PrepaidMonthlyRM: "-", // DO LATER
            MonthlyPrepaidAccumulationRM: "-", // DO LATER
            MonthlyUsageRM: (cost_map.get(date) || 0).toFixed(2),
            ContractUsageToDateRM: "-", // DO LATER
            MonthlyBalanceRM: "-",
            ContractPrepaidBalanceRM: "-",
            PLMarketing: revenue_marketing.get(date) + cost_marketing.get(date) || 0,
            PLService: revenue_service.get(date) + cost_service.get(date) || 0,
            PLUtility: revenue_utility.get(date) + cost_utility.get(date) || 0,
            PLAuth: revenue_authentication.get(date) + cost_authentication.get(date) || 0,
            PLUnkown: Number(revenue_unknown.get(date).toFixed(2)) + Number(cost_unknown.get(date).toFixed(2)) || 0,
            PLSession: parseFloat(((uniqueNumbers.get(parseInt(date)) || 0) * pricing_data[0].session).toFixed(2)) - parseFloat(((uniqueNumbers.get(parseInt(date)) || 0) * company_pricing[0].session).toFixed(2)),
          };

          // Add the entry to the array
          generatedData.push(entry);
        }

        setDummyData((prevData) => [...prevData, ...generatedData]);
        break;
      default:
        setDummyData([]);
    }
  };


  const column_data = [
    "Contract",
    "Date",
    "TotalMsg",
    "MarketingMsg",
    "ServiceMsg",
    "UtilityMsg",
    "UknownTypeMsg",
    "AuthenticationMsg",
    "TotalUniqueSession",
    "TotalUniqueUser",
    "MarketingRM",
    "ServiceRM",
    "UtilityRM",
    "UknownTypeRM",
    "AuthenticationRM",
    "SessionRM",
    "PrepaidFullPeriodRM",
    "PrepaidMonthlyRM",
    "MonthlyPrepaidAccumulationRM",
    "UsageRM",
    "ContractUsageToDateRM",
    "MonthlyBalanceRM",
    "ContractPrepaidBalanceRM",
    "PLMarketing",
    "PLService",
    "PLUtility",
    "PLAuth",
    "PLUnkown",
    "PLSession"

  ];

  const [dummyData, setDummyData] = useState([]);

  const columns = column_data.map((key) => ({
    title: key,
    dataIndex: key,
    key,
    innerWidth: 100,
  }));

  const csvData = dummyData.length > 0
  ? [
      Object.keys(dummyData[0]),
      ...dummyData.map((item) => Object.values(item)),
    ]
  : [];

  const customComponents = {
    header: {
      cell: (props) => <th style={{ background: '#00B1FF', color: 'black' }}>{props.children}</th>,
    },
    body: {
      cell: (props) => <td style={{ background: '#1F2022', color: 'white' }}>{props.children}</td>,
    },
    footer: {
      cell: (props) => <td style={{ background: 'black', color: 'gold' }}>{props.children}</td>,
    },
  };

  const side_margin = '20px';

  // const paginationConfig = {
  //   itemRender: (current, type, originalElement) => {
  //     if (type === 'prev' || type === 'next' || type === 'jump-prev' || type === 'jump-next') {
  //       return (
  //         <span style={{ color: '#00B1FF' }}>
  //           {type === 'prev' && <LeftOutlined />}
  //           {type === 'next' && <RightOutlined />}
  //           {type === 'jump-prev' && <DoubleLeftOutlined />}
  //           {type === 'jump-next' && <DoubleRightOutlined />}
  //         </span>
  //       );
  //     }
  //     return <span style={{ color: '#00B1FF' }}>{current}</span>;
  //   },
  // };

  const fileName = "Summary " + selectedContract +".csv";

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Layout style={{ minHeight: '98vh' }}>
       <Sidebar location={location} />
        <Layout style={{ background: 'white'}}>
          <div className="layout-content" style={{ margin: side_margin, justifyContent: "right" }}>
            <Row className="rowgap-vbox" gutter={[6, 24]}>
              <Col xs={24} sm={24} md={24} lg={6} xl={6} className="mb-24">
                <Card bordered={false} className="criclebox" style={{ width: "350px", height: "150px", backgroundColor: "#FFFFFF" }}>
                  <div className="number">
                    <Row align="middle" justify="center">
                      <Col xs={50}>
                        <span style={{ fontSize: '30px' }}>Chat-Bot</span>
                      </Col>
                    </Row>
      
                    <Row align="middle" justify="center">
                      <Col xs={50}>
                        <Select
                          id="contractSelect"
                          value={selectedContract}
                          onChange={(value, option) => handleDropdownChange(value, option.key)}
                          style={{ width: 150, marginLeft: "8px" }}
                        >
                          {contractOptions.map((option, index) => (
                            <Select.Option key={index} value={option}>
                              {option}
                            </Select.Option>
                          ))}
                        </Select>
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Col>
            </Row>
      
            {/* Add some margin to create a gap */}
            {/* <div style={{ margin: "10px 0" }}></div> */}
          </div>

          <div style={{ display: "flex", flexDirection: "row", margin: side_margin, justifyContent: "space-between"}}>
              {/* <Card bordered={false} style={{ width: "100%", alignItems: "right", marginRight: "20px", backgroundColor: "#FFFFFF"}}> */}
                {/* <ScrollableTable data = {data} chatbot_contract = {[id, selectedContract]} mainUrl = {mainUrl} pricing_data={customer_pricing_data} company_pricing ={company_pricing_data}/>                 */}
                <div style={{ padding: "10px", maxWidth: "100%", height: "1000px", overflowY: "auto", overflowX: "auto", backgroundColor: "#FFFFFF"}}>
                  <Card style={{backgroundColor: "#FFFFFF", height: "900px"}}>
                    <div style={{ marginBottom: "16px", display: "flex", justifyContent: "space-between" , backgroundColor: "#FFFFFF"}}>
                      <div>
                        {/* Add your contract selection logic here */}
                      </div>
                      <div>
                        <label htmlFor="timePeriodSelect" style={{ color: 'white' }}>Select Time Period:</label>

                        <Select
                          id="timePeriodSelect"
                          value={selectedTimePeriod}
                          onChange={(value) => setSelectedTimePeriod(value)}
                          style={{ width: 150, marginLeft: "8px" }}
                        >
                          {timePeriodOptions.map((option, index) => (
                            <Select.Option key={index} value={option}>
                              {option}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    
                    <Table
                      dataSource={dummyData}  // Replace dummyData with your actual data source
                      columns={columns}
                      scroll={{ x: 5000, y: 600 }} // Set your desired width for the table
                      // components={customComponents}
                      // pagination={paginationConfig}
                    />

                    <div style={{ display: "flex", alignItems: "center", marginTop: "16px" }}>
                      <CSVLink data={csvData} filename={fileName}>
                        <Button icon={<DownloadOutlined />}>Download CSV</Button>
                      </CSVLink>
                    </div>
                  </Card>
                </div>  
              {/* </Card> */}
          </div>
        </Layout>
      </Layout>

  );

};

export default ScrollableTable;